import { useUserServices } from "../../hooks/useUserService";
import { User } from "../../types/user";

interface ServicesTabProps {
    user: User;
}

export default function ServicesTab({ user }: ServicesTabProps) {
    const services = useUserServices(user.email || user.phone || "");
    console.log("User services", services);
    return (
        <div className="w-full bg-card rounded-xl p-4">
        <table className="w-full text-xs table-fixed">
            <thead className="border-b border-gray-400 text-gray-200">
                <tr>
                    <th className="w-1/10 text-center font-light py-2">Service</th>
                    <th className="w-1/10 text-center font-light py-2">Joined On</th>
                    <th className="w-1/10 text-center font-light py-2">Location</th>
                    <th className="w-1/10 text-center font-light py-2">Device</th>
                    <th className="w-1/10 text-center font-light py-2">Status</th>
                    <th className="w-1/10 text-center font-light py-2">Action</th>
                </tr>
            </thead>

            <tbody className="text-white">
                {services.map((service) => (
                    <tr className="bg-card/50">
                        <td className="w-1/10 text-center py-2">{service.serviceName}</td>
                        <td className="w-1/10 text-center py-2">{service.dateRegistered}</td>
                        <td className="w-1/10 text-center py-2">{service.location}</td>
                        <td className="w-1/10 text-center py-2">Android</td>
                        <td className="w-1/10 text-center py-2 text-green-500">Active</td>
                        <td className="w-1/10 text-center py-2">
                            <button className="bg-none border border-white text-white rounded-lg py-1 px-2 hover:scale-105 cursor-pointer">Deactivate</button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        </div>
    );
}